import React, { useState, useEffect } from 'react';
import { Routes, Route, Link, useLocation, useNavigate } from 'react-router-dom';

//import * as SVG from './SVG';
import {SVGHome, SVGMoneyNote, SVGBucket, SVGUsers, SVGCalendar} from './SVG';

function NavigationItem({ to, label, icon: Icon }) {
    const location = useLocation();
    const isActive = location.pathname === to;

    return (
        <Link to={to} className='flex flex-col gap-1 basis-full	'>
            <Icon classes={`h-5 ${isActive ? 'fill-slate-900 dark:fill-white' : 'fill-slate-300 dark:fill-slate-700'}`} />
            <span className={`block text-center text-xs font-medium ${isActive ? 'text-slate-900 dark:text-white' : 'text-slate-500'}`}>{label}</span>
        </Link>
    );
}

function NavigationBar({ scrollAtBottom }) {
    return (
        <div className={`fixed w-full z-50 bottom-0 left-0 px-2 navigation-bar-spacing flex justify-around gap-1 before:block before:absolute before:left-0 before:top-0 before:w-full before:h-full before:bg-white/30 before:backdrop-blur-xl before:border-t-[1px] before:border-black/10 dark:before:bg-slate-950/30 dark:before:border-white/10 before:z-[-1] before:transition-opacity before:duration-100 ${scrollAtBottom ? 'before:opacity-0' : ''}`}>
            <NavigationItem to="/" label="Home" icon={SVGHome} />
            <NavigationItem to="/spending" label="Spending" icon={SVGMoneyNote} />
            <NavigationItem to="/buckets" label="Buckets" icon={SVGBucket} />
            <NavigationItem to="/people" label="People" icon={SVGUsers} />
            <NavigationItem to="/budget" label="Budget" icon={SVGCalendar} />
        </div>
    );
}

export default NavigationBar;